import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { STATES } from './ZillowReviews/Component';
import Ratings from './Ratings';

function ReviewsAverageRating({
  zillowData: { avgRating, profileURL, reviewCount },
  staticContent,
  state
}) {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: 'small',
      paddingTop: 'xxsmall',
      textAlign: 'center',
      marginLeft: 'auto',
      marginRight: 'auto',
      borderBottom: '1px solid rgb(232,232,232)'
    },
    title: {
      fontWeight: 'bold'
    },
    rating: {
      display: 'flex',
      justifyContent: 'center'
    }
  };

  return (
    <UX2.Element.Block style={ styles.container }>
      <UX2.Element.Text style={ styles.title }>{ staticContent.averageRatingTitle }</UX2.Element.Text>
      <Ratings rating={ avgRating } style={ styles.rating } />
      { state === STATES.LOADED && (
        <UX2.Element.Details>
          <UX2.Element.Link
            target='_blank'
            href={ profileURL }
            children={ `(${staticContent.viewAllReviewsPrefix} ${reviewCount} ${staticContent.viewAllReviewsSuffix})` }
          />
        </UX2.Element.Details>
      ) }
    </UX2.Element.Block>
  );
}

ReviewsAverageRating.propTypes = {
  zillowData: PropTypes.object,
  staticContent: PropTypes.object,
  state: PropTypes.string
};

export default ReviewsAverageRating;
